<script setup lang="ts">
import { inject, ref } from "vue";
import { Router, useRouter } from "vue-router";
import DarkModeToggle from '@/components/layout/DarkModeToggle.vue';
import Search from '@/components/search/SearchField.vue';
import UserHeaderMenu from '@/components/navigation/UserHeaderMenu.vue';
import SupportHeaderMenu from '@/components/navigation/SupportHeaderMenu.vue';
import routeManager from "@/router/route-manager";
import { useMenuPermissions } from "@/composables/menu-permissions";
import type { LabelService } from "@/composables/label-service";
import { labelServiceSymbol } from "@/plugins/LabelServicePlugin";
import SocialHeaderMenu from "@/components/navigation/SocialHeaderMenu.vue";
const { showMainSearch } = useMenuPermissions();

const router: Router = useRouter();
const labelService = inject<LabelService>( labelServiceSymbol ) as LabelService;

const showMobileMenu = ref( false );
router.beforeEach( () => {
  showMobileMenu.value = false;
} );

const {
  showBonusReportOption
} = useMenuPermissions();

async function navigateToSecurityDetails ( ticker: string ) {
  await router.push( routeManager.buildSecurityPath( ticker ) );
}

async function navigateToSectorDetails ( symbol: string ) {
  await router.push( routeManager.sectorDetailsRouteBySymbol( symbol ) );
}
</script>

<template>
  <div class="bg-base-100 border-b shadow">
    <div class="flex justify-between items-center">
      <Search v-if=" showMainSearch "
        class="m-2 ml-10 lg:ml-4 min-w-[275px]"
        :stock-click-handler="navigateToSecurityDetails"
        :etf-click-handler="navigateToSecurityDetails"
        :sector-click-handler="navigateToSectorDetails" />
      <div class="flex items-center">
        <router-link v-if="showBonusReportOption" class="btn btn-primary btn-sm" :to="routeManager.bonusReportsSearchPath()">
          <i class="pi pi-file-pdf"></i>
          <span class="hidden lg:inline items-center gap-2 text-s">{{ labelService.label( 'lblBonusReports' ) }}</span>
        </router-link>
        <SocialHeaderMenu />
        <SupportHeaderMenu />
        <UserHeaderMenu />
        <DarkModeToggle />
      </div>
    </div>
  </div>
</template>